import React from "react";
import Axios from "axios";
import { useTranslation } from 'react-i18next';
import { makeStyles } from "@material-ui/core/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import AnyQuestionsComponent from "components/MyComponents/AnyQuestionsComponent";

import styles from "assets/jss/material-kit-react/views/landingPage.js";
import brandImage from "assets/img/iese-logo-navbar.png";
import ReactCountryFlag from "react-country-flag"
import { Button } from "@material-ui/core";
import PersonalInformationInside from "views/PersonalInformationPage/PersonalInformationPageInside";
import config from "assets/config/config.json";
import { ClipLoader } from "react-spinners";
import SnackbarContent from "components/Snackbar/SnackbarContent";
import { withRouter } from "react-router-dom";


const useStyles = makeStyles(styles);

function PersonalInformationPage(props) {
    const { history } = props;
    const { t } = useTranslation();
    const classes = useStyles();
    const { ...rest } = props;
    const [error, setError] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [items, setItems] = React.useState(null);
    const [personalInfo, setPersonalInfo] = React.useState(null);

    React.useEffect(() => {
        Axios.get(config.checklogin)
            .then(
                (_result) => {
                    Axios.get(config.getQuote)
                        .then(
                            (result) => {
                                setItems(result.data);
                                // setIsLoaded(true);
                            },
                            (error) => {
                                // setIsLoaded(true);
                                setError(error);
                            });

                    Axios.get("/getpersonalinfodata")
                        .then(
                            (result) => {
                                setPersonalInfo(result.data);
                                setIsLoaded(true);
                            },
                            (error) => {
                                // if (error && error.response && error.response.status === 404) {
                                //     history.replace('/paymentmethod?errorid=404');
                                // }
                                setError(error);
                                setIsLoaded(true);
                            });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    setIsLoaded(false);
                    setError(error);
                }
            )
    }, []);
    if (error && error.response && error.response.status === 403) {
        console.log('PersonalInformationPage: Error status 403');
        history.replace('/auth');
        window.location.reload();
    }
    else if (error && error.response && error.response.status === 404) {
        console.log('PersonalInformationPage: Error status 404');
        history.replace('/paymentmethod?errorid=404');
        window.location.reload();
    }
    else if (error) {
        history.replace('/help');
        window.location.reload();
        console.log('PersonalInformationPage: Generic error');
    }
    else if (!isLoaded) {
        console.log('PersonalInformationPage: Not Loaded');
        return (
            <div>
          <Header key={1}
                color="dark"
                sticky
                breadcrumb={[{ text: t("PersonalInformationHeader_Title"), selected: true, isbutton: false }, { text: t("PersonalInformationHeader_PaymentMethod"), selected: false, isbutton: false }]}
                    />
            <div
                style={{
                    position: 'absolute', left: '50%', top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            >
                <ClipLoader

                    size={200}
                    color={"#504a4a"}
                />
            </div></div>);
    }
    else {
        return (
            <div>
                <Header key={3}
                    color="dark"
                    brand={<img style={{ filter: "brightness(0) invert(1)" }}
                        src={brandImage}
                        className={classes.img}
                        alt="brand"
                    />}
                    sticky
                    userData={items}
                    breadcrumb={[{ text: t("PersonalInformationHeader_Title"), selected: true, isbutton: false }, { text: t("PersonalInformationHeader_PaymentMethod"), selected: false, isbutton: false }]}
                    {...rest}
                />
                <SnackbarContent
                    message={
                        <span style={{ padding: "10px 0" }}>
                            {t("Fields")}
                        </span>
                    }
                    id="info"
                    color="danger"
                    icon="warning_rounded"
                    close
                />
                <SnackbarContent
                    message={
                        <span>
                            {t("ServerError")}
                        </span>
                    }
                    id="error"
                    color="danger"
                    icon="warning_rounded"
                    close
                />
                <PersonalInformationInside
                    personalInfoData={personalInfo}></PersonalInformationInside>
                <AnyQuestionsComponent />
                <Footer whiteFont />
            </div>
        );
    }
}
export default withRouter(PersonalInformationPage);